import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import _ from 'lodash';
import cx from 'classnames';

import { Urls } from 'constants/constants';


import Link, { selectLinks } from 'store/models/Link';
import Scene, { selectScenesByAccount } from 'store/models/Scene';
import RouteState from 'store/RouteState';

import { ContentCenter, Title, Header, HeaderLeft, HeaderRight, Breadcrumbs } from 'components/Content';
import { LinkList } from 'components/LinkItem';
import SceneStrip from 'components/SceneStrip';

import { Card, CardHead, CardTitle, CardItem } from 'components/Card';

// ======================
// STORE
// ======================
const actions = {
  fetchData: () => dispatch => Promise.all([
    dispatch(Link.actions.fetchLinks()),
    dispatch(Scene.actions.getSceneLibrary()),
  ]),
  navigate: RouteState.actions.navigate,
}

const selectors = createSelector(
  state => selectScenesByAccount(state),
  state => selectLinks(state),
  (scenes, links) => Object.assign({ scenes, links }),
);

const withConnect = connect(selectors, actions);



// ======================
// COMPONENT
// ====================== 
class MediaScreen extends React.Component {
  state = {}

  componentDidMount() {
    this.props.fetchData();
  }

  onEditLink = link => this.props.navigate(Urls.LINK_EDIT_ROUTE, { linkId: link?._id })
  onNewLink = () => this.props.navigate(Urls.LINK_NEW)

  render() {
    let { links, scenes } = this.props;
    return (
    <ContentCenter className="assets">
      <Header split={true}>
        <HeaderLeft>
          <Title>Media</Title>
        </HeaderLeft>
      </Header>
      <Card>
        <CardHead>
          <CardTitle>Slides</CardTitle>
        </CardHead>
        <CardItem>
          <SceneStrip 
            scenes={scenes}
            enableSort={false} />
        </CardItem>
      </Card>
      <Card>
        <CardHead>
          <CardTitle>Links</CardTitle>
        </CardHead>
        <LinkList
          header={true}
          links={links}
          onEdit={this.onEditLink} />
      </Card>
      
    </ContentCenter>);
  }
}
export default MediaScreen
  |> withConnect;